<div class="header mt-md-5">
  <a [routerLink]="'/client-questionnaires'" href=""><i class="fa fa-chevron-left"></i> Retourner aux questionnaires
client</a>

<div class="header-body">

  <div class="row align-items-center calculation-status-bar">
    <div class="col">

      <!-- Title -->
      <h1 class="header-title d-flex align-items-center">
        {{ getClientName() }} <small class="ms-3">({{ getClientEmail() }})</small>
        <span [class.bg-light]="this.clientQuestionnaireStatus === 'CREATED'"
          [class.bg-success]="this.clientQuestionnaireStatus === 'FINALIZED'"
          [class.bg-warning]="this.clientQuestionnaireStatus === 'IN_PROGRESS'"
          class="ms-5 badge rounded-pill bg-warning"
          style="font-size: 70%;"

        >{{ getStatusText() }}</span>
      </h1>

      <div class="mt-4">
        <div class="d-block d-sm-inline mb-3 mb-sm-0">
          <i class="fad fa-poll-h"></i>
          <strong class="ms-2">{{ getTitleText() }}</strong>
        </div>

        <div class="ms-sm-5 d-block d-sm-inline">Dernière modification: <strong
        class="lastModifiedText">{{ getLastModifiedText() }}</strong></div>

        <div class="ms-sm-5 d-block d-sm-inline">
          <button (click)="convertToCalculation()"
            [disabled]="convertingClientQuestionnaireStatus === ViewStateEnum.Loading"
            class="btn btn-outline-primary">

            @if (convertingClientQuestionnaireStatus === ViewStateEnum.Loading) {
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              Conversion en cours...
            } @else {
              <span><i
              class="fas fa-exchange"></i> Convertir en calcul </span>
            }
          </button>
        </div>
      </div>

      @if (this.clientQuestionnaireResponse.status !== clientQuestionnaireStatusEnum.Finalized) {
        <div
          class="mt-4">
          Envoyez le lien ci-dessous à votre client pour qu'il puisse remplir le questionnaire.
          <div class="input-group mb-3" style="max-width: 800px;">
            <input [value]="getLink()" aria-describedby="button-addon2" aria-label="Recipient's username"
              class="form-control" disabled placeholder="Recipient's username"
              readonly type="text">
            <button (click)="copyToClipboard()" class="btn btn-primary" id="button-addon2" type="button"><i
            class="far fa-copy"></i>
          </button>
        </div>
        @if (hasCopied) {
          <div class="text-success"><i class="fas fa-check"></i> Copié</div>
        }
        <a [href]="mailtoLink()" class="btn btn-light mt-3"
          target="_blank"><i class="fas fa-paper-plane"></i> Envoyer par courriel</a>
        </div>
      }


    </div>
  </div> <!-- / .row -->

  <div class="row">
    <div class="col-12">
      <app-alert-messages></app-alert-messages>
    </div>
  </div>
</div>
</div>

<div>
  <app-salary-dividend-tax-questionnaire-form [isReadOnly]="true"></app-salary-dividend-tax-questionnaire-form>
</div>

